import React, { useEffect, useState, useContext, useRef } from 'react';
import { ProductModalContext } from '../../ProductModalContext';

import { Button } from 'web-store-modules/packages/web-store-ui-library'

import { BuyNowOnce, BuyNowClicked, AddToCartClicked, ProductQuantitySelectorClicked } from '../../../../../../utils/Analytics';
// import ProductModalDropdown from './dropdown-button/ProductModalDropdown.jsx';
// import ProductModalCartOverlay from './ProductModalCartOverlay';
import { AddToCartContext } from '../../../../add-to-cart/AddToCartContext';
import SizeSelector from './size-selector/SizeSelector';
import ColorDropdownSelector from './color-dropdown-selector/ColorDropdownSelector';
import { formatShopifySku } from '../util/ProductModalHelpers.js';
import { storeId } from '../../../../../../../../variables/Variables';
import { popupStoreId } from '../../../../../../utils/StoreConfigManager';


const ProductModalButtons = ({ sku, title, price, downsizedThumbnail, buttonFontStyle,
    addToCartFontStyle, buyNowFontStyle, productButtonCopy,
    addToCartCopy, url, cartUrl, setShowingAddToCartPrompt,
    addToCartEnabled, sizeDropdownEnabled, groupProducts, fontStyles, onClose }) => {

    const { colors, buttonBorderRadius, buttonBorderWidth, buyNowBorderActiveOn, addToCartBorderActiveOn, productInfo, variantSize, setVariantSize, variantColor, productVariantMap, selectedVariantSKU, baseSKU } = useContext(ProductModalContext);
    const { addToCart, removeFromCart, cartList, updateFromCart, cartSubTotal, setCartSubTotal, itemCount } = useContext(AddToCartContext);
    const [isInWishlist, setIsInWishlist] = useState(false);
    const [firstSeenInWishlistButton, setFirstSeenInWishlistButton] = useState(false);
    const [outOfStock, setOutOfStock] = useState(false);
    const [showLearnMore, setShowLearnMore] = useState(false);
    const [currentVarientItemInfo, setVariantInfo] = useState({})
    const [productQty, setProductQty] = useState(1)
    const [sizeError ,setSizeError] = useState('')
    const [addedToWishList, setAddedToWishList] = useState(false);
    const addedWishListRef = useRef(null);
    const [isSizeSelector ,setIsSizeSelector] = useState('without-size-option');
    let productItemInfo = {};

    useEffect(() =>{
        setProductQty(1);
        return(()=>{
            clearTimeout(addedWishListRef.current);
        })
    }, [])

    useEffect(() => {
        const productTitleAndSize = `${title}_${variantSize}`;
        if (cartList.find(item => item.TITLE_AND_SIZE === productTitleAndSize)) {
            productItemInfo = cartList.find(item => item.TITLE_AND_SIZE === productTitleAndSize);
            setIsInWishlist(true);
            setVariantInfo(productItemInfo);
        } else {
            productItemInfo = {};
            setIsInWishlist(false);
            setVariantInfo(productItemInfo);
        }
        // if(Object.keys(productInfo?.variants?.features_map)[0] !== "Default Title"){
            // setIsSizeSelector('')
        // }
    }, [cartList, variantSize])

    useEffect(() => {
        if (selectedVariantSKU !== null) {
            const stockStatus = !productInfo.variants.siblings[selectedVariantSKU]?.available;
            setOutOfStock(stockStatus);
        };
    }, [selectedVariantSKU])

    useEffect(() => {
        if (variantSize) {
            setSizeError('')
        };
    }, [variantSize])

    useEffect(() => {
        setProductQty(1)
    }, [currentVarientItemInfo])

    const buyButtonClicked = () => {
        BuyNowOnce();
        BuyNowClicked(sku, title);
        window.open(url, '_blank');
    }
    const addToCartClicked = () => {
        if (outOfStock) {
            console.log("enter in outOfStock")
            return;
        }
        // addToCart is only active when the item isn't in the cart/wishlist
        // if (isInWishlist && firstSeenInWishlistButton) {
        //     return;
        // }

        // addToCart is only active when variantSize and variantSize are set
        if (sizeDropdownEnabled && !variantSize) {
            setSizeError('Please select a size')
            return;
        }
        // const shopifyVariantId = productInfo?.variants?.features_map[variantSize];
        const shopifyVariantId = null;
        const productTitleAndSize = `${title}_${variantSize}`;
        productItemInfo = cartList.find(item => item.TITLE_AND_SIZE === productTitleAndSize);
        const obsesssku = formatShopifySku(sku);
        
        setAddedToWishList(true);
        addedWishListRef.current = setTimeout(()=>{
            setAddedToWishList(false);
            setProductQty(1);
        }, 2000);

        addToCart({
            TITLE: title,
            SIZE: variantSize,
            TITLE_AND_SIZE: productTitleAndSize,
            PRICE: price,
            DOWNSIZED_THUMBNAIL: downsizedThumbnail,
            VARIANT_ID: shopifyVariantId,
            QUANTITY: productQty,
            SKU: obsesssku,
            BASESKU: baseSKU
        });
        let updatedCount = currentVarientItemInfo?.QUANTITY ? productQty + currentVarientItemInfo.QUANTITY : productQty;
        let updatedVarientPrice = productQty * parseFloat(price);
        const subTotal = cartSubTotal + updatedVarientPrice;
        setCartSubTotal(subTotal);
        const size = (variantSize === "Default Title") ? '' : variantSize;
        AddToCartClicked(title, baseSKU, size);
        setFirstSeenInWishlistButton(true);
    }

    const UpdateItemQuantity = () => {
        console.log(itemCount)
        setProductQty(productQty + 1)
        setFirstSeenInWishlistButton(true);
        ProductQuantitySelectorClicked(title, baseSKU, 'increase')
    }

    const decreaseItemQuantity = () => {
        if(productQty > 1){
            setProductQty(productQty - 1)
        }
        const productTitleAndSize = `${title}_${variantSize}`;
        productItemInfo = cartList.find(item => item.TITLE_AND_SIZE === productTitleAndSize);
        if(productItemInfo && productItemInfo.QUANTITY === 1) {
            setFirstSeenInWishlistButton(true);
        }

        ProductQuantitySelectorClicked(title, baseSKU, 'decrease')
    }

    const renderCartText = () => {
        if (outOfStock) {
            return "OUT OF STOCK";
        }
        if ((storeId !== popupStoreId) && isInWishlist && firstSeenInWishlistButton) {
            return 'ADDED TO CART';
        }
        if (addedToWishList) {
            return 'ADDED TO CART';
        }
        return addToCartCopy;
    }

    const renderItemQuantity = () =>{
        return currentVarientItemInfo.QUANTITY || 1;
    }

    const addToCartColors = () => {
        return colors && colors.addToCartPrimaryColor;
    }

    if (buttonFontStyle) {
        buttonFontStyle.fontFamily = "OpenSans-Regular";
    }

    return (
        <div>
            <div className="">
                {/* <div className="d-flex column-50"></div> */}
                <div className="" style={{textAlign:'center'}}>
                    <div className="input-group quantity-box" style={{fontFamily: "OpenSans-Regular"}}>
                        <input type="button" value="-" className="button-minus" data-field="quantity" onClick={decreaseItemQuantity} />
                        <span style={{fontFamily: "OpenSans-Regular"}}>{productQty}</span>
                        <input type="button" value="+" className="button-plus" data-field="quantity" onClick={UpdateItemQuantity} />
                    </div>
                </div>
            </div>
            <div className={isInWishlist ? `product-button-container ${isSizeSelector}` :`product-button-container without-quantity ${isSizeSelector}`} style={{ width: addToCartEnabled && url ? '100%' : '50%' }}>
                {sizeDropdownEnabled &&
                    <SizeSelector
                        sku={sku}
                        groupProducts={groupProducts}
                        variantSize={variantSize}
                        setVariantSize={setVariantSize}
                        colors={colors}
                        productVariantMap={productVariantMap}
                        // defaultSize={productInfo.variants.variant}
                        // groupSizes={Object.keys(productInfo?.variants?.features_map)}
                        groupSizes={[]}
                        outOfStock={outOfStock}
                        errMsg={sizeError}
                        title={title}
                    />
                }
                {addToCartEnabled && <Button
                    hoverStyleChange={false}
                    onClick={addToCartClicked}
                    primaryColor={addToCartColors()}
                    secondaryColor={colors && colors.addToCartSecondaryColor}
                    className={`product-button flex-center obsessvr-boldFont full-width pointer ${addedToWishList ? 'disabled' : 'addToCart'}`}
                    style={{ padding: '0', margin: '0 1%', borderRadius: '0px' }}
                    primaryBorderWidth={addToCartBorderActiveOn && addToCartBorderActiveOn.primary ? buttonBorderWidth : undefined}
                    secondaryBorderWidth={addToCartBorderActiveOn && addToCartBorderActiveOn.secondary ? buttonBorderWidth : undefined}
                    primaryBorderColor={colors && colors.addToCartBorderColor}
                    secondaryBorderColor={colors && colors.addToCartBorderColor}
                    insetBorder={true}
                    padded={false}
                >
                    <p className='obsessvr-boldFont' style={{ ...buttonFontStyle, color: 'red' }}>
                        {renderCartText()}
                    </p>
                </Button>}
                {showLearnMore && <Button
                    hoverStyleChange={true}
                    onClick={buyButtonClicked}
                    primaryColor={colors && colors.buyNowPrimaryColor}
                    secondaryColor={colors && colors.buyNowSecondaryColor}
                    className="product-button flex-center obsessvr-regularFont full-width pointer learnMore"
                    style={{ padding: '0', margin: '0 1%', borderRadius: '0px' }}
                    primaryBorderWidth={buyNowBorderActiveOn && buyNowBorderActiveOn.primary ? buttonBorderWidth : undefined}
                    secondaryBorderWidth={buyNowBorderActiveOn && buyNowBorderActiveOn.secondary ? buttonBorderWidth : undefined}
                    primaryBorderColor={colors && colors.buyNowBorderColor}
                    secondaryBorderColor={colors && colors.buyNowBorderColor}
                    insetBorder={true}
                    padded={false}
                >
                    <p className='obsessvr-regularFont' style={addToCartFontStyle} /*style={buttonFontStyle}*/>
                        {(productButtonCopy !='') ? productButtonCopy : 'LEARN MORE'}
                    </p>
                </Button>}
            </div>
            <div className="d-flex column-50" style={{fontSize:'12px',fontFamily:"OpenSans-Regular",color:"#F00", position: 'absolute',bottom: '-3px'}}>{sizeError}</div>
        </div>
    )
}

export default ProductModalButtons;
